export default {
  translation: {
    translation_eng: 'en',
    translation_zhHant: 'zhHant',
    lang_eng: 'ENGLISH',
    lang_zhHant: '繁中',
    wallet: '收款系統',
    add_value: '增值',
    payment: '繳費',
    account_record: '戶口記錄',
    my_balance: '我的結餘',
    hkd: '港幣',
    bank_transfer: '銀行轉帳',
    bank_slip: '銀行發票',
    select_image: '選擇圖像',
    confirm: '確認',
    cancel: '取消',
    in_progress: '進行中',
    completed: '已完成',
    cancelled: '已取消',
    invoice: '帳單',
    invoice_no: '帳單 #',
    loading: '',
    pull_down_to_refresh: '請下拉刷新',
    release_to_refresh: '放開刷新',
    not_enough_value: '餘額不足',
    online_add_value: '網上增值',
    other_payment_method: '其他繳費方法',
    spc_wallet: 'SPC 餘額',
    alipay: '支付寶',
    wechat_pay: '微信支付',
    fps: '轉數快',
    payme: 'PayMe',
    paypal: 'PayPal',
    paypal_auth: 'PayPal',
    edda: 'eDDA',
    credit_card: '信用卡',
    new_credit_card: '新增信用卡',
    payee_bank_name: '銀行戶口上的英文姓名',
    total: '總額',
    payment_deadline: '繳費期限',
    no_payment_record: '暫無繳費帳單',
    spc_wallet_not_enough_msg: '您的SPC 餘額不足，請問您現在是否打算增值您的SPC 餘額？',
    which_payment_method_msg: '請選擇您的繳費方法',
    which_credit_card_msg: '請選擇您的信用卡',
    amount: '金額',
    custom: '自訂',
    expiry_date: '到期日子',
    cvv: 'CVV',
    credit_card_number: '信用卡號碼',
    expense: '支出',
    redeem: '存入',
    refund: '退還',
    ok: 'OK',
    service_charge: '服務費',
    item_total: '金額',
    cms: 'CMS',
    login: '登入',
    cms_school_calender: '校曆表',
    cms_timetable: '時間表',
    cms_user_list: '人員名單',
    cms_user_list_class: '班別名單',
    cms_user_list_group: '組別名單',
    cms_user_list_chat_group: '聊天群組名單',
    cms_user_list_student: '學生名單',
    cms_user_list_parent: '家長名單',
    cms_user_list_teacher: '教師名單',
    cms_user_list_admin: '管理員名單',
    cms_management: '管理',
    cms_class_management: '班別管理',
    cms_group_management: '組別管理',
    cms_subject_management: '科目管理',
    cms_attendance_system: '考勤系統',
    cms_reply_slip: '電子回條',
    cms_payment_system: '收款系統',
    cms_payment_system_add_value: '手動增值',
    cms_payment_system_add_value_record: '家長增值記錄',
    cms_payment_system_payment_record: '家長支付記錄',
    cms_payment_system_reply_slip_management: '繳費通告管理',
    cms_payment_system_account_management: '帳目管理',
    cms_daily_verse: '每日金句',
    cms_school_news: '校園新聞',
    cms_library: '電子圖書館',
    cms_school_tv: '校園電視',
    cms_promotion: '升班管理',
    cms_mobile_theme: '手機應用主題',
    cms_description: '說明',
    cms_agenda: '議程',
    add_value_amount: '增值金額',
    student_number: '學生編號',
    student_chinese_name: '學生中文姓名',
    student_english_name: '學生英文姓名',
    class_number: '班別學號',
    class_id: '班別',
    remove: '移除',
    preview: '預覽',
    photo: '相片',
    select_files: '選擇文件...',
    reset_password: '重設密碼',
    enter_new_password: '輸入新密碼',
    balance: '結餘',
    authority: '權限',
    access: '存取',
    success: '成功',
    fail: '失敗',
    manual_validate: '手動驗証',
    payment_success: '付款成功',
    payment_fail: '未能驗証付款紀錄，請稍候再試',
    paypal_validation_fail: '未能驗証付款紀錄，請稍候再試或選擇其他付款方法',
    invoice_paying_notice: '我們正在驗証你的付款紀錄，請在付款後或稍候再查看',
    invoice_paid_notice: '已成功付款, 請參閱以下付款紀錄資料',
    invoice_auth_notice: '我們已暫時扣起了以下項目的款項',
    invoice_cancel_notice: '帳單已取消',
    invoice_expired: '帳單已過期',
    fps_tutor_name_same: '款付銀行用戶姓名：',
    fps_tutorial:
      '點擊二維碼儲存到手機後，再匯入到個人手機銀行APP轉數快二維碼付款功能進行付款。',
    fps_paid_notice: '如果你已成功付款，請等待學校確認。',
    change_method: '選擇其他付款方法',
    change_method_notice: '如你已經成功付款，請勿選擇轉用其他付款方法，否則你已成功付款的記錄將會無法被確認。',
  },
}
